import React, { useEffect, useState, useRef } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardHeaderIcon,
  CardHeaderToolbar,
  ModalProgressBar,
} from '../../../../../_metronic/_partials/controls';
import ChangedInfo from '../../../../components/ChangedInfo';
import Activities from '../../../../components/Activities';
import * as actions from '../../_redux/sales/salesActions';
import {
  initialSale,
  SaleStatusCssClasses,
  SaleStatusTitles,
} from '../SalesUIHelpers';
import SaleMain from './Sale/SaleMain';

export function SaleViewDialog({
  history,
  match: {
    params: { id },
  },
}) {
  const intl = useIntl();
  const [tab, setTab] = useState('sale');
  const [title, setTitle] = useState('');
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [dialogError, setDialogError] = useState('');
  const titleText = intl.formatMessage({ id: 'SALES.TITLE.DETAIL' });
  /*const refShipping = useRef();
  const [shippingResult, setShippingResult] = useState({
    boxes: [],
    items: [],
  });*/
  //console.log('id=', id);

  const { actionsLoading, saleForView, error, msg } = useSelector(
    (state) => ({
      actionsLoading: state.sales.actionsLoading,
      saleForView: state.sales.saleForView,
      error: state.sales.error,
      msg: state.sales.msg,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.fetchSale(id));
  }, [id, dispatch]);

  useEffect(() => {
    let _title = intl.formatMessage({ id: 'SALES.QUICKACTIONS.TITLE' });
    console.log('saleForView', saleForView);
    if (saleForView && id) {
      _title = `${titleText}: #${saleForView.id}`;
    }

    setTitle(_title);
  }, [saleForView, id]);

  useEffect(() => {
    setDialogError(error);
  }, [error]);

  const onHide = () => {
    history.push(`/sales`);
  };

  const saveSale = (values) => {
    if (!loading) {
      setLoading(true);
      //console.log('saveSale', values, saleForView);
      if (!saleForView) {
        dispatch(actions.createSale(values));
      } else {
        dispatch(actions.updateSale(values));
        dispatch(actions.fetchSale());
      }
      setLoading(false);
    }
  };

  const newClick = () => {
    dispatch(actions.clearSale());
    dispatch(actions.fetchSale());
    history.push('/sales/new');
  };
  const btnRefNew = useRef();
  const newSaleClick = () => {
    //console.log('saveSaleClick');
    if (btnRefNew && btnRefNew.current) {
      btnRefNew.current.click();
    }
  };
  const btnRefSave = useRef();
  const saveSaleClick = () => {
    //console.log('saveSaleClick');
    if (btnRefSave && btnRefSave.current) {
      btnRefSave.current.click();
    }
  };
  const closeOrderClick = () => {
    if (!loading) {
      setLoading(true);
      //console.log('saveSale', values, saleForView);
      dispatch(actions.closeOrder(saleForView.saleCode));
      dispatch(actions.fetchSale());
      //history.push(`/sales/${saleForView.saleCode}/edit`);
      setLoading(false);
    }
  };

  const btnRefCancel = useRef();
  const cancelSaleClick = () => {
    //console.log('saveSaleClick');
    if (btnRefCancel && btnRefCancel.current) {
      btnRefCancel.current.click();
    }
  };

  return (
    <>
      <Modal.Body className='overlay overlay-block cursor-default'>
        {actionsLoading && <ModalProgressBar />}
        {actionsLoading && (
          <div className='overlay-layer bg-transparent'>
            <div className='spinner spinner-lg spinner-success' />
          </div>
        )}
        <Card>
          <CardHeader title={`${title}`}>
            <CardHeaderToolbar>
              <> </>
              <button
                type='button'
                onClick={cancelSaleClick}
                className='btn btn-light btn-elevate'
              >
                <FormattedMessage id='GENERAL.BUTTON.CANCEL' />
              </button>
              <> </>
              <button
                type='button'
                className='btn btn-secondary ml-2'
                onClick={newSaleClick}
                disabled={saleForView && saleForView.saleCode ? false : true}
              >
                <FormattedMessage id='GENERAL.BUTTON.NEW' />
                {loading && (
                  <span
                    id='saleSaveLoading3'
                    className='ml-3 spinner spinner-white '
                  ></span>
                )}
              </button>
              <> </>
              {saleForView &&
                saleForView.saleType === 'ORDER' &&
                saleForView.status !== 8 && (
                  <button
                    type='button'
                    className='btn btn-info ml-2'
                    onClick={closeOrderClick}
                  >
                    <FormattedMessage id='SALES.BUTTON.CLOSEORDER' />
                    {loading && (
                      <span
                        id='saleSaveLoading2'
                        className='ml-3 spinner spinner-white '
                      ></span>
                    )}
                  </button>
                )}
              <> </>
              {tab === 'sale' && (
                <button
                  type='submit'
                  className='btn btn-primary ml-2'
                  onClick={saveSaleClick}
                >
                  <FormattedMessage id='GENERAL.BUTTON.SAVE' />
                  {loading && (
                    <span
                      id='saleSaveLoading2'
                      className='ml-3 spinner spinner-white '
                    ></span>
                  )}
                </button>
              )}
            </CardHeaderToolbar>
          </CardHeader>
          <CardBody>
            <ul className='nav nav-tabs nav-tabs-line ' role='tablist'>
              <li className='nav-item' onClick={() => setTab('sale')}>
                <a
                  className={`nav-link ${tab === 'sale' && 'active'}`}
                  data-toggle='tab'
                  role='tab'
                  aria-selected={(tab === 'sale').toString()}
                >
                  Бүртгэл
                </a>
              </li>
              <li className='nav-item' onClick={() => setTab('activity')}>
                <a
                  className={`nav-link ${tab === 'activity' && 'active'}`}
                  data-toggle='tab'
                  role='button'
                  aria-selected={(tab === 'activity').toString()}
                >
                  Өөрчлөлтийн түүх
                </a>
              </li>
            </ul>
            <div className='mt-5'>
              {tab === 'sale' && (
                <>
                  <div className='form-group row'>
                    <div className='col-12'>
                      <SaleMain
                        actionsLoading={actionsLoading}
                        saleForView={saleForView || initialSale}
                        initialSale={initialSale}
                        btnRefSave={btnRefSave}
                        btnRefNew={btnRefNew}
                        saveSale={saveSale}
                        newClick={newClick}
                        btnRefCancel={btnRefCancel}
                        onHide={onHide}
                        dialogError={dialogError}
                        msg={msg}
                      />
                    </div>
                  </div>
                </>
              )}
              {tab === 'activity' && id && (
                <Activities saleCode={saleForView.id} />
              )}
            </div>
          </CardBody>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        {saleForView && (
          <ChangedInfo
            value={{
              createdByName: saleForView.createdByName,
              createdAt: saleForView.createdAt,
              updatedByName: saleForView.createdByName,
              updatedAt: saleForView.updatedAt,
            }}
          />
        )}
      </Modal.Footer>
    </>
  );
}
